module.exports = __webpack_public_path__ + "media/images/emblems/Guggisberg-coat_of_arms-10c3b2ab4766b9311fe9957b695f9768.svg";